import { docTypesChile, docTypesPeru, docTypesColombia } from '@constants/user';
import { getEnv } from '@config';

const { country } = getEnv();
export const docTypesByCountry = { cl: docTypesChile, pe: docTypesPeru, co: docTypesColombia }[
  country
];
export const defaultDocType = docTypesByCountry[0]?.value || '';
